import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
// import { Paper, Input } from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
// import theme from "theme";

//const useStyles = {
//   root: {
//     borderRadius: '4px',
//     alignItems: 'center',
//     // padding: theme.spacing(1),
//     display: 'flex',
//     flexBasis: 420
//   },
//   icon: {
//     // marginRight: theme.spacing(1),
//     //  color: theme.palette.icon
//   },
//   input: {
//     flexGrow: 1,
//     fontSize: '14px',
//     lineHeight: '16px',
//     letterSpacing: '-0.05px'
//   }
// };

const SearchInput = props => {
  const { className, onChange, style, ...rest } = props;


  return (
    <div
      // {...rest}
      // className={clsx(useStyles.root, className)}
      // style={style} useStyles.input
    >
      {/* <SearchIcon className={useStyles.icon} /> */}
      <input
        // {...rest}
        className={''}
        disableUnderline
        onChange={onChange}
      />
    </div>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SearchInput;
